const installationActionTypes =  {    
    PARSED_INSTALLATION_PACKAGE: "PARSED_INSTALLATION_PACKAGE",
    GO_TO_WIZARD_STEP: "GO_TO_WIZARD_STEP",
    INSTALLED_EXTENSION_LOGS: "INSTALLED_EXTENSION_LOGS",
    CLEAR_PARSED_INSTALLATION_PACKAGE: "CLEAR_PARSED_INSTALLATION_PACKAGE",
    INSTALLING_AVAILABLE_PACKAGE: "INSTALLING_AVAILABLE_PACKAGE",
    NOT_INSTALLING_AVAILABLE_PACKAGE: "NOT_INSTALLING_AVAILABLE_PACKAGE",
    SET_FAILED_INSTALLATION_LOGS: "SET_FAILED_INSTALLATION_LOGS",
    TOGGLE_ACCEPT_LICENSE: "TOGGLE_ACCEPT_LICENSE",
    TOGGLE_VIEWING_LOG: "TOGGLE_VIEWING_LOG",
    SET_IS_PORTAL_PACKAGE: "SET_IS_PORTAL_PACKAGE"
};
export default installationActionTypes;